import type { FastifyInstance } from 'fastify'
import type { Firestore } from 'firebase-admin/firestore'
import { BillingRepository } from './billing.repository.js'
import { BillingService } from './billing.service.js'
import { BillingController } from './billing.controller.js'
import { billingRoutes } from './billing.routes.js'
import { setBillingService } from './billing.container.js'
import { UsersRepository } from '../users/users.repository.js'

export default async function billingModule(
  app: FastifyInstance,
  firestore: Firestore
) {
  const repository = new BillingRepository(firestore)
  const usersRepository = new UsersRepository(firestore)
  const service = new BillingService(repository, usersRepository)
  setBillingService(service)
  const controller = new BillingController(service)

  await billingRoutes(app, controller)
}
